"use strict";

exports.__esModule = true;
exports.default = void 0;

var _initialState = _interopRequireDefault(require("./initialState"));

var _actions = require("../actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var appReducer = function appReducer(state, _ref) {
  if (state === void 0) {
    state = _initialState.default;
  }

  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _actions.GET_CONSUMPTION_DETAILS_REQUEST:
      return _extends({}, state, {
        isLoading: true,
        hasError: false
      });

    case _actions.GET_CONSUMPTION_DETAILS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        hasError: false,
        consumptionDetails: _extends({}, payload)
      });

    case _actions.GET_CONSUMPTION_DETAILS_FAILURE:
      return _extends({}, state, {
        isLoading: false,
        hasError: true
      });

    default:
      return state;
  }
};

var _default = appReducer;
exports.default = _default;